import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { HowItWorksComponent } from './components/how-it-works/how-it-works.component';
import { PackagesComponent } from './components/packages/packages.component';
import { CustomersComponent } from './components/customers/customers.component';
import { AboutComponent } from './components/about/about.component';
import { ContactComponent } from './components/contact/contact.component';
import { AydinlatmaMetniComponent } from './components/legal/aydinlatma-metni/aydinlatma-metni.component';
import { CerezBilgilendirmeMetniComponent } from './components/legal/cerez-bilgilendirme-metni/cerez-bilgilendirme-metni.component';
import { AcikRizaMetniComponent } from './components/legal/acik-riza-metni/acik-riza-metni.component';
import { VeriSorumlusuComponent } from './components/legal/shared/veri-sorumlusu/veri-sorumlusu.component';
import { KvkkHaklarinizComponent } from './components/legal/shared/kvkk-haklariniz/kvkk-haklariniz.component';
import { LegalLinksComponent } from './components/legal/shared/legal-links/legal-links.component';

const routes: Routes = [
  { path: '', component: HomeComponent, data: { title: 'Keyo AI - E-ticaret için Yapay Zeka Asistanı' } },
  { path: 'how-it-works', component: HowItWorksComponent, data: { title: 'Nasıl Çalışır | Keyo AI' } },
  { path: 'packages', component: PackagesComponent, data: { title: 'Paketler | Keyo AI' } },
  { path: 'customers', component: CustomersComponent, data: { title: 'Müşteri Hikayeleri | Keyo AI' } },
  { path: 'about', component: AboutComponent, data: { title: 'Hakkımızda | Keyo AI' } },
  { path: 'contact', component: ContactComponent, data: { title: 'İletişim | Keyo AI' } },
  { path: 'aydinlatma-metni', component: AydinlatmaMetniComponent, data: { title: 'Aydınlatma Metni | Keyo AI' } },
  { path: 'cerez-bilgilendirme-metni', component: CerezBilgilendirmeMetniComponent, data: { title: 'Çerez Bilgilendirme Metni | Keyo AI' } },
  { path: 'acik-riza-metni', component: AcikRizaMetniComponent, data: { title: 'Açık Rıza Metni | Keyo AI' } },
  { path: '**', redirectTo: '' }
];

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    HomeComponent,
    HowItWorksComponent,
    PackagesComponent,
    CustomersComponent,
    AboutComponent,
    ContactComponent,
    AydinlatmaMetniComponent,
    CerezBilgilendirmeMetniComponent,
    AcikRizaMetniComponent,
    VeriSorumlusuComponent,
    KvkkHaklarinizComponent,
    LegalLinksComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 80],
    }),
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { } 